function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import WKTWriter from '../../io/WKTWriter';
import Coordinate from '../../geom/Coordinate';
import IntervalRTreeLeafNode from './IntervalRTreeLeafNode';
import IntervalRTreeNode from './IntervalRTreeNode';
import Collections from '../../../../../java/util/Collections';
import System from '../../../../../java/lang/System';
import ArrayList from '../../../../../java/util/ArrayList';
import IntervalRTreeBranchNode from './IntervalRTreeBranchNode';
var SortedPackedIntervalRTree = /*#__PURE__*/function () {
  function SortedPackedIntervalRTree() {
    _classCallCheck(this, SortedPackedIntervalRTree);
    SortedPackedIntervalRTree.constructor_.apply(this, arguments);
  }
  return _createClass(SortedPackedIntervalRTree, [{
    key: "buildTree",
    value: function buildTree() {
      Collections.sort(this._leaves, new IntervalRTreeNode.NodeComparator());
      var src = this._leaves;
      var temp = null;
      var dest = new ArrayList();
      while (true) {
        this.buildLevel(src, dest);
        if (dest.size() === 1) return dest.get(0);
        temp = src;
        src = dest;
        dest = temp;
      }
    }
  }, {
    key: "insert",
    value: function insert(min, max, item) {
      if (this._root !== null) throw new IllegalStateException('Index cannot be added to once it has been queried');
      this._leaves.add(new IntervalRTreeLeafNode(min, max, item));
    }
  }, {
    key: "query",
    value: function query(min, max, visitor) {
      this.init();
      this._root.query(min, max, visitor);
    }
  }, {
    key: "buildRoot",
    value: function buildRoot() {
      if (this._root !== null) return null;
      this._root = this.buildTree();
    }
  }, {
    key: "printNode",
    value: function printNode(node) {
      System.out.println(WKTWriter.toLineString(new Coordinate(node._min, this._level), new Coordinate(node._max, this._level)));
    }
  }, {
    key: "init",
    value: function init() {
      if (this._root !== null) return null;
      this.buildRoot();
    }
  }, {
    key: "buildLevel",
    value: function buildLevel(src, dest) {
      this._level++;
      dest.clear();
      for (var i = 0; i < src.size(); i += 2) {
        var n1 = src.get(i);
        var n2 = i + 1 < src.size() ? src.get(i) : null;
        if (n2 === null) {
          dest.add(n1);
        } else {
          var node = new IntervalRTreeBranchNode(src.get(i), src.get(i + 1));
          dest.add(node);
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SortedPackedIntervalRTree;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { SortedPackedIntervalRTree as default };
SortedPackedIntervalRTree.constructor_ = function () {
  this._leaves = new ArrayList();
  this._root = null;
  this._level = 0;
};